import React, { useEffect } from 'react';

function Toast({ message, type, onClose, duration = 3000 }) {
    useEffect(() => {
        if (!message) return;
        const timer = setTimeout(onClose, duration);
        return () => clearTimeout(timer);
    }, [message, duration, onClose]);

    if (!message) return null;

    return (
        <div style={{
            position: 'fixed',
            top: '20px',
            right: '20px',
            zIndex: 9999,
            padding: '14px 22px',
            borderRadius: '8px',
            color: '#fff',
            fontWeight: '600',
            fontSize: '15px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
            backgroundColor: type === 'success' ? '#28a745' : '#dc3545',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            animation: 'fadeIn 0.3s ease',
        }}>
            <span>{type === 'success' ? '✅' : '❌'}</span>
            {message}
        </div>
    );
}

export default Toast;